
if ('function' === typeof importScripts) {
    importScripts('https://cdn.onesignal.com/sdks/OneSignalSDKWorker.js');
}


// WEBPACK FOOTER //
// ./OneSignalSDKUpdaterWorker.js